// src/components/HomePage/HomePage.jsx

import React, { useState, useEffect } from 'react';
import Navbar from '../Navbar/Navbar';
import HeroSection from '../HeroSection/HeroSection';
import ProductFinder from '../ProductFinder/ProductFinder';
import FeaturedProducts from '../FeaturedProducts/FeaturedProducts';
import WhyUsSection from '../WhyUsSection/WhyUsSection';
import Footer from '../Footer/Footer';

// --- GÜNCELLENDİ: Firebase importları ---
import { db } from '../firebase/firebase-config'; 
// doc ve getDoc eklendi (Hero Section için)
import { collection, getDocs, query, orderBy, doc, getDoc } from 'firebase/firestore'; 
// Markaları statik olarak alıyoruz
import { brands } from '../data/productData'; 
import BrandSlider from '../BrandSlider/BrandSlider';

function HomePage() {
  // Filtreleme state'leri
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState(null); 
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [priceRange, setPriceRange] = useState({ min: '', max: '' }); 

  // Veri state'leri
  const [allProducts, setAllProducts] = useState([]);
  const [categories, setCategories] = useState([]); 
  const [loading, setLoading] = useState(true); // Ürünler/Kategoriler için

  // --- YENİ: Hero Section verisi için state'ler ---
  const [heroData, setHeroData] = useState({
    title: 'SANCAK: ÇÖZÜM.', // Firebase yüklenemezse varsayılan
    description: 'Modern Mutfakların Kalbi ve Her İşin Sağlam Temeli',
    showButton: true,
    imageUrl: '' // Başlangıçta boş
  });
  const [loadingHero, setLoadingHero] = useState(true); // Hero için ayrı yüklenme state'i

  // Verileri çek (Ürünler, Kategoriler VE Hero Ayarları)
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setLoadingHero(true);
      try {
        // Paralel sorgular
        const categoriesQuery = query(collection(db, "categories"), orderBy("name", "asc"));
        const productsQuery = query(collection(db, "products"), orderBy("createdAt", "desc"));
        const heroDocRef = doc(db, "site_settings", "hero_section"); // Hero ayarları
        
        const [categorySnapshot, productSnapshot, heroDocSnap] = await Promise.all([
          getDocs(categoriesQuery),
          getDocs(productsQuery),
          getDoc(heroDocRef) // Hero dokümanını çek
        ]);

        // Kategoriler
        const categoryList = categorySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setCategories(categoryList);
        
        // Ürünler
        const productList = productSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setAllProducts(productList);
        
        // Hero Verisi
        if (heroDocSnap.exists()) {
          setHeroData(heroDocSnap.data());
        } else {
          console.warn("Hero section ayarları Firestore'da bulunamadı!");
        }
        
      } catch (error) {
        console.error("Firebase'den veri çekerken hata:", error);
      }
      setLoading(false); // Ürünlerin yüklenmesi bitti
      setLoadingHero(false); // Hero'nun yüklenmesi bitti
    };
    fetchData();
  }, []); // Sadece ilk yüklemede çalışır

  // --- Filtre Fonksiyonları (Bileşen içinde) ---

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setSelectedCategory(null); 
    setSelectedBrand(null);
  };

  const handleCategorySelect = (categoryName) => {
    const newCategory = selectedCategory === categoryName ? null : categoryName;
    setSelectedCategory(newCategory);
    setSearchQuery(''); 
    setSelectedBrand(null);
  };

  const handleBrandSelect = (brandId) => {
    const newBrand = selectedBrand === brandId ? null : brandId;
    setSelectedBrand(newBrand);
    setSearchQuery('');
    setSelectedCategory(null);
  };

  const handlePriceChange = (event) => {
    const { name, value } = event.target;
    if (/^\d*$/.test(value)) {
      setPriceRange(prev => ({ ...prev, [name]: value }));
    }
  };

  // --- Görüntülenecek Ürünleri Hesaplama ---
  const featuredProducts = allProducts.slice(0, 4);
  const isSearching = searchQuery.trim() !== '';
  const isFiltering = selectedCategory || selectedBrand || priceRange.min || priceRange.max;

  const getDisplayedProducts = () => {
    let filtered = [...allProducts]; // 'this.' olmadan

    if (isSearching) {
      filtered = filtered.filter(p =>
        p.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (p.mainCategoryName && p.mainCategoryName.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (p.sku && p.sku.toLowerCase().includes(searchQuery.toLowerCase()))
      );
    } 
    else if (selectedCategory) {
      filtered = filtered.filter(p => p.mainCategoryName === selectedCategory);
    } else if (selectedBrand) {
      filtered = filtered.filter(p => p.brandId === selectedBrand);
    }

    const minPrice = parseFloat(priceRange.min);
    const maxPrice = parseFloat(priceRange.max);

    if (!isNaN(minPrice) || !isNaN(maxPrice)) {
      filtered = filtered.filter(p => {
        const price = p.price;
        const passesMin = isNaN(minPrice) || price >= minPrice;
        const passesMax = isNaN(maxPrice) || price <= maxPrice;
        return passesMin && passesMax;
      });
    }
    
    if (!isSearching && !isFiltering) {
      return featuredProducts;
    }
    return filtered;
  };

  return (
    <div>
        <Navbar/>
        <BrandSlider />
        {/* --- HERO SECTION (DİNAMİK) --- */}
        {/* Yüklenirken boş bir alan göster (veya bir placeholder) */}
        {loadingHero ? (
          <div style={{ height: '60vh', backgroundColor: '#333' }}></div> // Basit placeholder
        ) : (
          <HeroSection
            pageType="large"
            title={heroData.title} // Firebase'den
            description={heroData.description} // Firebase'den
            showButton={heroData.showButton} // Firebase'den
            backgroundImageUrl={heroData.imageUrl} // Firebase'den
          />
        )}
        
        <ProductFinder
          searchQuery={searchQuery}
          onSearchChange={handleSearchChange}
          categories={categories}
          onCategorySelect={handleCategorySelect}
          activeCategory={selectedCategory}
          brands={brands}
          onBrandSelect={handleBrandSelect}
          activeBrand={selectedBrand}
          priceRange={priceRange}
          onPriceChange={handlePriceChange}
        />
        
        <FeaturedProducts
          products={getDisplayedProducts()}
          isSearching={isSearching}
          loading={loading} // Bu 'loading' ürünler içindir
          selectedCategory={selectedCategory}
          selectedBrand={selectedBrand}
          isFiltering={isFiltering}
        />
        
        <WhyUsSection/>
        <Footer/>
    </div>
  )
}

export default HomePage;